module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div data-region="installed-search"></div><h5 hidden data-title="installed-headline">'+
((__t=( i18n.tc( "UnitInstallFlow", "My installed devices" ) ))==null?'':__t)+
'</h5><div class="pagination-strip btns-9 clearfix" data-element="pagination-strip" data-input="pagination-strip"><nav aria-label="Pagination"><ul data-container="pagination-strip"></ul></nav></div><div data-region="installed-container"></div>';
}
return __p;
};
